import { StyledSkeletonTable, Line, Th, Td } from "@/components/ui/Loaders/SkeletonTable/styles.ts";

export const SkeletonTable = ({ rows, cols }: {rows: number; cols: number}) => (
    <StyledSkeletonTable>
        <tbody>
        {[...Array(rows)].map((_, rowIndex) => (
            <tr key={rowIndex}>
                {[...Array(cols)].map((_, colIndex) => (
                    rowIndex === 0 ? (
                        <Th align='center' key={colIndex}>
                            <div style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                <Line />
                            </div>
                        </Th>
                    ) : (
                        <Td align='center' key={colIndex}>
                            <div style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                <Line/>
                            </div>
                        </Td>
                    )
                ))}
            </tr>
        ))}
        </tbody>
    </StyledSkeletonTable>
);
